module.exports = __webpack_public_path__ + "img/chatHeaderLogo2.950e0605.svg";